import React from 'react';
import _ from 'lodash';
import { ZiggeoRecorder,  ZiggeoPlayer } from 'react-ziggeo';
import { ZIGGEO_API_KEY, DUMMY_TOKENS } from '../constants';
import Spinner from '../../../../../../../components/Spinner/';

import './IntroduceYourself.scss';

class IntroduceYourself extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
			isLoading: false,
      id: _.get(props, 'SelfIntro.getSelfIntro.id', null),
      videoToken: _.get(props, 'SelfIntro.getSelfIntro.videoToken', ''),
			otherVideoTokens: _.get(props, 'SelfIntro.getSelfIntro.otherVideoTokens', []),
      // otherVideoTokens: DUMMY_TOKENS,
    };
  }

	unsetVideo = () => this.setState({ videoToken: '' });

  setVideoToken = () => {
		if (!this.ziggeoRecorder) {
			return {};
		}

    let recorder = this.ziggeoRecorder.recorderInstance();
    let videoToken = recorder.get("video");

    return this.setState({ videoToken });
  }

  onError = () => this.setState({ videoToken: '' });

  sendVideo = () => {
		this.setState({ isLoading: true });

		return this.props.SubmitSelfIntroVideo({ variables: { videoToken: this.state.videoToken } })
			.then(({ data }) => this.setState({ isLoading: false, id: data.setVideoAnswer.id }))
			.then(() => this.props.SelfIntro.refetch());
	};

  removeVideo = () => {
		this.setState({ isLoading: true });

	  return this.props.RemoveSelfIntroVideo({ variables: { videoRecordId: this.state.id } })
			.then(() => this.setState({ isLoading: false, id: null, videoToken: '' }));
  };

  renderOtherVideos = () => this.state.otherVideoTokens.map(token =>
    <div className="col-md-4">
      <ZiggeoPlayer
        apiKey={ZIGGEO_API_KEY}
        video={token}
        width="100%"
        height="100%"
        responsive
        locale="en"
        theme="modern"
        onRef={ref => (this.child = ref)}
      />
    </div>
  );

	renderPlayer = () => {
    const isNewVideo = !_.get(this.props, 'SelfIntro.getSelfIntro.videoToken');

		if (isNewVideo) {
			return (
				<ZiggeoRecorder
          apiKey={ZIGGEO_API_KEY}
          width="100%"
          theme="modern"
          locale="en"
          countdown={3}
          responsive
          onRef={ref => (this.ziggeoRecorder = ref)}
          onAttached={this.setVideoToken}
          onRerecord={this.unsetVideo}
          onLoaded={this.setVideoToken}
          onError={this.unsetVideo}
					onProcessed={this.setVideoToken}
					onVerified={this.setVideoToken}
        />
			);
		}
		return (
			<ZiggeoPlayer
	      apiKey={ZIGGEO_API_KEY}
	      video={this.state.videoToken}
	      width="100%"
	      height="100%"
	      responsive
	      locale="en"
	      theme="modern"
	      onRef={ref => (this.child = ref)}
		  />
		);
  }

  render() {
    const isNewVideo = !_.get(this.props, 'SelfIntro.getSelfIntro.videoToken');
		const { videoToken, isLoading, otherVideoTokens } = this.state;
		const isSendButtonDisplayed = isNewVideo && videoToken;
		const isRemoveButtonDisplayed = !isNewVideo && videoToken;

    console.log("videotokens:", videoToken, otherVideoTokens);
    return (
      <div>
        <div className="box">
          <h1 className="heading">Introduce Yourself</h1>
          <p className="description">
            { videoToken ? '' : 'Please record a ~1 minute video introducing yourself, why you enjoy coaching, and what you hope to help students with.' }
          </p>

          <div className="video">
            { isLoading ? <Spinner /> : this.renderPlayer() }
          </div>
          { isSendButtonDisplayed && <button onClick={this.sendVideo} className="SaveIntroVideo__button">Send Video</button> }
          { isRemoveButtonDisplayed &&	<button onClick={this.removeVideo} className="RemoveVideo__button">Remove video</button> }
        </div>

        <div className="box">
          <p> Other Advisors videos </p>
          <div className="row previewVideosWrapper">
            { otherVideoTokens.length ? this.renderOtherVideos() : 'Sorry, nothing to show' }
          </div>
        </div>
      </div>
    );
  }
};

export default IntroduceYourself;



// WEBPACK FOOTER //
// ./src/routes/advisor/routes/Profile/routes/SelfIntro/components/IntroduceYourself.js